module.exports = __webpack_public_path__ + "media/images/pages/deadpool_twitter-c9e3df953e01ce414b9b8ec873cac1dd.jpg";